import React from 'react';
import { clipboardIcon, type PathElement, type RectElement } from '@chordbaker/design';

const [clip, board, textLines] = clipboardIcon.elements as [RectElement, PathElement, PathElement];

const ClipboardIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox={clipboardIcon.viewBox}
    fill={clipboardIcon.fill}
    stroke={clipboardIcon.stroke}
    strokeWidth={clipboardIcon.strokeWidth}
    strokeLinecap={clipboardIcon.strokeLinecap as React.SVGAttributes<SVGSVGElement>['strokeLinecap']}
    strokeLinejoin={clipboardIcon.strokeLinejoin as React.SVGAttributes<SVGSVGElement>['strokeLinejoin']}
    {...props}
  >
    <rect x={clip.x} y={clip.y} width={clip.width} height={clip.height} rx={clip.rx} />
    <path d={board.d} />
    <path d={textLines.d} />
  </svg>
);

export default ClipboardIcon;
